import React from 'react';
import { cn } from '../utils/cn';

/**
 * Label Component - Atom
 * 
 * @param {Object} props
 * @param {string} props.size - 'sm' | 'md' | 'lg'
 * @param {boolean} props.required - Show required indicator
 * @param {string} props.htmlFor - Label for attribute
 */
const Label = React.forwardRef(
  (
    {
      size = 'md',
      required = false,
      className = '',
      children,
      htmlFor,
      ...props
    },
    ref
  ) => {
    const baseStyles = 'block font-medium text-primary-900 dark:text-primary-50';

    const sizes = {
      sm: 'text-sm',
      md: 'text-base',
      lg: 'text-lg',
    };

    return (
      <label
        ref={ref}
        htmlFor={htmlFor}
        className={cn(baseStyles, sizes[size], className)}
        {...props}
      >
        {children}
        {required && (
          <span className="text-error-500 ml-1" aria-label="required">
            *
          </span>
        )}
      </label>
    );
  }
);

Label.displayName = 'Label';

export default Label;
